"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = exports.MathUtils = exports.AABBUtils = exports.BlockFace = exports.RaycastIterator = exports.InterceptFunctions = exports.AABB = void 0;
const utilFunctions_1 = require("./utilFunctions");
function inject(bot) {
    bot.util = new utilFunctions_1.UtilFunctions(bot);
}
exports.default = inject;
var aabb_1 = require("./calcs/aabb");
Object.defineProperty(exports, "AABB", { enumerable: true, get: function () { return aabb_1.AABB; } });
var intercept_1 = require("./calcs/intercept");
Object.defineProperty(exports, "InterceptFunctions", { enumerable: true, get: function () { return intercept_1.InterceptFunctions; } });
var iterators_1 = require("./calcs/iterators");
Object.defineProperty(exports, "RaycastIterator", { enumerable: true, get: function () { return iterators_1.RaycastIterator; } });
Object.defineProperty(exports, "BlockFace", { enumerable: true, get: function () { return iterators_1.BlockFace; } });
var static_1 = require("./static");
Object.defineProperty(exports, "AABBUtils", { enumerable: true, get: function () { return static_1.AABBUtils; } });
Object.defineProperty(exports, "MathUtils", { enumerable: true, get: function () { return static_1.MathUtils; } });
Object.defineProperty(exports, "Task", { enumerable: true, get: function () { return static_1.Task; } });
